import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import PropTypes from 'prop-types';
import React from 'react';
import { compose } from 'redux';
import withTypeAdd from '../../HOCs/withTypeAdd';

const DeviceManufacturersAdd = props => {
    const {
        data: { name },
        errors,
        t
    } = props;

    return (
        <React.Fragment>
            <FormControl
                fullWidth
                required
                error={!!errors.name}
                margin="normal"
            >
                <InputLabel
                    htmlFor="DeviceManufacturer"
                    variant="standard"
                >
                    {t('deviceManufacturer')}
                </InputLabel>
                <Input
                    id="DeviceManufacturer"
                    autoFocus
                    name="name"
                    value={name || ''}
                    onChange={props.handleChange}
                />
                {errors.name && (
                    <FormHelperText>
                        {t(errors.name)}
                    </FormHelperText>
                )}
            </FormControl>
        </React.Fragment>
    );
};

const validate = data => {
    const errors = {};

    if (!data.name) errors.name = 'nameIsRequired';
    else if (data.name.length > 255) errors.name = 'deviceManufacturerDescriptionCannotBeLonger255';

    return errors;
};

DeviceManufacturersAdd.propTypes = {
    handleChange: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

export default compose(withTypeAdd(validate))(DeviceManufacturersAdd);
